import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/Login'
import ssoLogin from '@/components/ssoLogin'
import Main from '@/components/Main'
import Register from '@/components/Register'
import Forget from '@/components/Forget'
import User from '@/components/user/User'
import _403 from '@/components/403'


import indx from '@/components/index/router'

/**
 * 基础项目管理
 */
import fund from '@/components/fund/router'
// 导向计划，项目管理
import guidefund from '@/components/guide/fund/router'

//企业信息管理
import ente from '@/components/ente/router'

// 项目信息
import proj from '@/components/proj/router'
// 项目进度
import prog from '@/components/prog/router'

//代码管理
import code from '@/components/code/router'

//中药饮片专项
import herbv1 from '../components/special/herb/v1/router'
//中药饮片专项(2018年第2批)
import herbv2 from '../components/special/herb/v2/router'
//中药饮片专项(2019年)
import herbv2019 from '../components/special/herb/v2019/router'

//2018中国制造2025
import china from '../components/special/china2025/v2018/router'
//2019中国制造2025
import chinav2019 from '../components/special/china2025/v2019/router'

//2019智能制造试点示范项目
import intelligent from '../components/special/intelligent/V2018/router'
import intelligent2019 from '../components/special/intelligent/V2019/router'
import intelligent2020 from '../components/special/intelligent/V2020/router'

import syst from '@/components/syst/router'
import awar from '@/components/awar/router'
import staff from '@/components/staff/router'

//经济运行处 规模以上工业企业培育奖励资金
import incentive2019 from '@/components/special/Incentive/v2019/router'

// 业务流程
import jc305 from '@/components/proc/jc305/router'
import jc306 from '@/components/proc/jc306/router'

// 工单管理
import task from '@/components/task/router'

// 园区项目
import park from '@/components/special/parkproject/v2018/router'
// 园区项目
import park2019 from '@/components/special/parkproject/v2019/router'

// 项目管理主界面(项目列表、项目历史数据管理）
import specialIndex from '@/components/special/index/router'

//中小企业发展专项管理界面（项目列表、历史数据管理）
import smesIndex from '../components/smes/index/router'

// 2019 中小企业处
import inco2019 from '@/components/proc/inco2019/router'
import patn2019 from '@/components/proc/patn2019/router'
import privt2019 from '@/components/proc/privt2019/router'


//铁运项目
import railage2019 from '@/components/special/railage/v2019/router'
import railage2020 from '@/components/special/railage/v2020/router'

//工业互联网（平台）
import internetPlatform2019 from '@/components/special/internet/platform/v2019/router'
//工业互联网（两化融合）
import internetDouble2019 from '@/components/special/internet/double/v2019/router'
//工业互联网（三化融合）

// 重大工业和信息化项目管理
import major2019 from '@/components/major/v2019/router'

//2020年工业转型升级重点项目
import guardChina2020 from '@/components/guide/china/v2020/router'

//2020年导向计划
import guideGuideIndex from '@/components/guide/guide/index/router'
import guideGuide2020 from '@/components/guide/guide/v2020/router'

//云南省2020年工业质量品牌提升重点项目
import majorBrand2020 from '@/components/guide/brand/v2020/router'

//2020年云南省工业互联网“三化”改造试点示范项目
import internetTriple2020 from '@/components/special/internet/triple/v2020/router'

//2020年法规、中小、技创项目
import china2020 from '../components/special/china2025/v2020/router'


// 2019 中小企业处
// import inco2019 from '@/components/proc/inco2019/router'
// import patn2019 from '@/components/proc/patn2019/router'
import privt2020 from '@/components/proc/privt2020/router'
import rail2020 from '@/components/proc/rail2020/router'

//2020年园区项目
import park2020 from '@/components/special/parkproject/v2020/router'

//2020年生物医药产业
import herb2020 from '@/components/special/herb/v2020/router'
import spyp2020b2 from '@/components/proc/spyp/2020b2/router'

//2020年投资项目管理
import inves2020 from '@/components/inves/inves/v2020/router'

//2021 3个100
import inves2021 from '@/components/inves/inves/v2021/router'

//2021 2021年重大龙头带动及产业链延链补链强链项目、绿色制造工程项目
import china2021 from '../components/special/china2025/v2021/router'

//2021 2021年省级技术改造与创新方向资金项目申请表
import innovation2021 from '../components/special/innovation/v2021/router'

// 2021年民营经济高质量发展方向资金项目申请表
import quality2021 from '../components/special/quality/v2021/router'

//2021园区项目
import park2021 from '../components/special/parkproject/v2021/router'

//2021服务型制造工程项目
import server2021 from '../components/special/server/v2021/router'

//2021年生产性物流项目补助申请表
import logistics2021 from '../components/special/logistics/v2021/router'

//2021年2021年云南省“三化”改造试点示范项目
import internet2021 from '../components/special/internet/v2021/router'

//2022年导向计划
import guideGuide2021 from '../components/guide/guide/v2021/router'

//2021年国家级专精特新“小巨人”企业研发经费投入补助资金
import research2021 from '../components/smes/research/v2021/router'

//2021年中小企业延链补链强链发展资金
import develop2021 from '../components/smes/develop/v2021/router'

//2021年中小企业引进首台（套）重大技术装备补助项目
import equipment2021 from '../components/smes/equipment/v2021/router'

//2021年中小企业“三化”改造试点示范项目补助资金
import triple2021 from '../components/smes/triple/v2021/router'

//2021年中小企业公共服务体系示范项目奖励资金
import service2021 from '../components/smes/service/v2021/router'

//2022年全省工业和信息化高质量发展项目
import inves2022 from '../components/inves/inves/v2022/router'

//建立云南省惠企政策申报系统平台
import policy2021 from '../components/smes/policy/v2021/router'

//2022年中小企业做优做强发展项目补助资金申报
import develop2022 from '../components/smes/develop/v2022/router'

//2022年省级专精特新“小巨人”企业培育奖补
import train2022 from '../components/smes/train/v2022/router'

//2022年中小企业首次贷款利息补贴资金申请表
import loan2022 from '../components/smes/loan/v2022/router'

//2022年中小企业公共服务体系示范项目
import service2022 from '../components/smes/service/v2022/router'

//中小生产服务型物流企业降成本补助
import logistics2022 from '../components/smes/logistics/v2022/router'

//园区处重大项目管理
import parkMajor2022 from '../components/major/park/v2022/router'

//2022年制造业重大项目方向补助资金_产业项目补助资金
import china2022 from '../components/special/china2025/V2022/router'

//2022年企业技术改造与创新方向补助资金
import innovation2022 from '../components/special/innovation/v2022/router'

//2022年绿色制造工程补助资金申请表
import green2022 from '../components/special/green/v2022/router'

//2022年绿色制造工程补助资金申请表
import server2022 from '../components/special/server/v2022/router'

//2022园区项目
import park2022 from '../components/special/parkproject/v2022/router'


//2021年生产性物流项目补助申请表
import transportation2022 from '../components/special/logistics/v2022/router'

//2023年导向计划
import guideGuide2022 from '../components/guide/guide/v2022/router'

// 2023年省级中小企业发展导向计划
import guideSmes2022 from '../components/guide/guide/smes/V2022/router'

//2023年全省工业和信息化高质量发展项目
import inves2023 from '../components/inves/inves/v2023/router'

//2023年制造业重大项目方向补助资金
import china2023 from '../components/special/china2025/V2023/router'

//2023年省级中小企业发展专项资金
import smes2023 from '../components/smes/V2023/router'

//2023年项目储备库管理
import projLibFund from '../components/projLib/fund/router'
import projLib2003 from '../components/projLib/V2003/router'

//工作流管理
import WfFlow from '../components/wf/router'

//2023年中小企业贷款贴息
import smesLoan2023 from '../components/smes/loan/v2023/router'

//2024年制造业重大项目方向
import china2024 from '../components/special/china2025/V2024/router'
//2024年配套重大项目的园区基础设施补短板项目
import park2024 from '../components/special/parkproject/v2024/router'
//2024年配套重大项目的园区基础设施补短板项目
import innovation2024 from '../components/special/innovation/v2024/router'
//2024年磷石膏综合利用方向
import gypsum2024 from '../components/special/gypsum/v2024/router'
//2024年中小企业技术升级改造建设项目补助资金
import renovation2024 from '../components/smes/renovation/v2024/router'
//2024年国家级专精特新“小巨人”奖励资金
import smesInnovation2024 from '../components/smes/innovation/v2024/router'
//2024年中小微企业首次贷款利息补贴资金,最后未申报
import smesLoan2024 from '../components/smes/loan/v2024/router'
//2024年中小企业数字化转型‘小灯塔’示范企业补助资金
import smesDigital2024 from '../components/smes/digital/v2024/router'
//2024年中小企业集群“链式”转型试点项目培育补助资金
import smesClusters2024 from '../components/smes/clusters/v2024/router'
//2024年中小企业公共服务体系示范项目奖补资金
import smesService2024 from '../components/smes/service/v2024/router'
//2023年度第二批优质中小企业银行贷款贴息
import smesLoan2024V2 from '../components/smes/loan/v2024_2/router'
//2024年灯塔工厂培育方向
import lighthouse2024 from '../components/special/lighthouse/v2024/router'
//2024年国家级专精特新“小巨人”企业奖励资金
import smesTrain2024 from '../components/smes/train/v2024/router'
//2024贷款贴息，2024年7月
import smesLoan2024V3 from '../components/smes/loan/v2024_3/router'
//2025年导向计划，2024年7月
import projLib2004 from '../components/projLib/V2024/router'
// 2024年云南消费名品方阵申报
import brand2024 from '../components/brand/V2024/router'
// 2025年省级工业和信息化领域专项资金
import china2025 from '../components/special/china2025/V2025/router'
// 2025年市场主体培育方向（国家级重点称号奖补）
import market2025 from '../components/smes/marketEntity/v2025/router'
//2024年优质中小企业贷款贴息情况汇总表
import load2025 from '../components/smes/loan/v2025/router'
// 2025年云南消费名品方阵申报
import brand2025 from '../components/brand/V2025/router'
//2026年导向计划，2025年7月
import projLib2005 from '../components/projLib/V2025/router'
//2024年磷石膏综合利用方向
import gypsum2025 from '../components/special/gypsum/v2025/router'
//云南省先进制造业股权投资基金
import equityInvestment2025 from '../components/special/equityInvestment/V2025/router'
// 2025促进工业经济增长财政资金-规上工业企业增产增效激励
import prodIncentive2025 from '../components/special/prodIncentive/v2025/router'
// 2025已完成投资项目（设备）补助
import investmentSubsidy2025 from '../components/special/investmentSubsidy/v2025/router'
//2025年规上工业企业贷款贴息
import load2025V2 from '../components/smes/loan/v2025_V2/router'



Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {public: true}
    },
    {
      path: '/ssologin',
      name: 'ssologin',
      component: ssoLogin,
      meta: {public: true}
    },
    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {public: true}
    },
    {
      path: '/forget',
      name: 'forget',
      component: Forget,
      meta: {public: true}
    },
    {
      path: '/',
      name: 'main',
      component: Main,
      children: [
        {
          path: '/user',
          name: 'user',
          component: User,
          meta: {public: true}
        },
        {
          path: '/403',
          name: '_403',
          component: _403,
          meta: {public: true}
        },
        ...indx.routes,
        ...syst.routes,
        ...proj.routes,
        ...prog.routes,
        ...awar.routes,
        ...staff.routes,
        ...ente.routes,
        ...code.routes,
        ...herbv1.routes,
        ...herbv2.routes,
        ...herbv2019.routes,
        ...jc305.routes,
        ...jc306.routes,
        ...fund.routes,
        ...china.routes,
        ...chinav2019.routes,
        ...intelligent.routes,
        ...intelligent2019.routes,
        ...task.routes,
        ...park.routes,
        ...park2019.routes,
        ...incentive2019.routes,
        ...inco2019.routes,
        ...patn2019.routes,
        ...privt2019.routes,
        ...specialIndex.routes,
        ...railage2019.routes,
        ...internetPlatform2019.routes,
        ...internetDouble2019.routes,
        ...major2019.routes,
        ...guardChina2020.routes,
        ...guidefund.routes,
        ...guideGuideIndex.routes,
        ...guideGuide2020.routes,
        ...majorBrand2020.routes,
        ...internetTriple2020.routes,
        ...privt2020.routes,
        ...rail2020.routes,
        ...intelligent2020.routes,
        ...china2020.routes,
        ...park2020.routes,
        ...herb2020.routes,
        ...inves2020.routes,
        ...railage2020.routes,
        ...spyp2020b2.routes,
        ...inves2021.routes,
        ...china2021.routes,
        ...innovation2021.routes,
        ...quality2021.routes,
        ...park2021.routes,
        ...server2021.routes,
        ...logistics2021.routes,
        ...internet2021.routes,
        ...guideGuide2021.routes,
        ...smesIndex.routes,
        ...research2021.routes,
        ...develop2021.routes,
        ...equipment2021.routes,
        ...triple2021.routes,
        ...service2021.routes,
        ...inves2022.routes,
        ...policy2021.routes,
        ...develop2022.routes,
        ...train2022.routes,
        ...loan2022.routes,
        ...service2022.routes,
        ...logistics2022.routes,
        ...parkMajor2022.routes,
        ...china2022.routes,
        ...innovation2022.routes,
        ...green2022.routes,
        ...server2022.routes,
        ...park2022.routes,
        ...transportation2022.routes,
        ...guideGuide2022.routes,
        ...inves2023.routes,
        ...guideSmes2022.routes,
        ...china2023.routes,
        ...smes2023.routes,
        ...projLibFund.routes,
        ...projLib2003.routes,
        ...WfFlow.routes,
        ...smesLoan2023.routes,
        ...china2024.routes,
        ...park2024.routes,
        ...innovation2024.routes,
        ...gypsum2024.routes,
        ...renovation2024.routes,
        ...smesInnovation2024.routes,
        ...smesLoan2024.routes,
        ...smesDigital2024.routes,
        ...smesClusters2024.routes,
        ...smesService2024.routes,
        ...smesLoan2024V2.routes,
        ...lighthouse2024.routes,
        ...smesTrain2024.routes,
        ...smesLoan2024V3.routes,
        ...projLib2004.routes,
        ...brand2024.routes,
        ...china2025.routes,
        ...market2025.routes,
        ...load2025.routes,
        ...brand2025.routes,
        ...projLib2005.routes,
        ...gypsum2025.routes,
        ...equityInvestment2025.routes,
        ...prodIncentive2025.routes,
        ...investmentSubsidy2025.routes,
        ...load2025V2.routes
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js